import type { SvgIconComponent } from '@mui/icons-material';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';

export const ALL_SERVICES = [
  'brands',
  'products',
  'blog',
  'products-units',
  'products-seo',
  'products-faq',
  'indexing',
] as const;

export type ServiceKey = (typeof ALL_SERVICES)[number];

export interface ServiceDef {
  key: ServiceKey;
  href: string;
  title: string;
  subtitle: string;
  icon: SvgIconComponent;
}

export const SERVICE_DEFS: Record<ServiceKey, ServiceDef> = {
  brands: {
    key: 'brands',
    href: '/brands',
    title: 'AI Brands',
    subtitle: 'SEO и FAQ брендов',
    icon: StorefrontOutlinedIcon,
  },
  products: {
    key: 'products',
    href: '/products',
    title: 'AI Products',
    subtitle: 'Категории и ветки',
    icon: CategoryOutlinedIcon,
  },
  blog: {
    key: 'blog',
    href: '/blog',
    title: 'AI Blog',
    subtitle: 'Статьи и контент',
    icon: AutoStoriesOutlinedIcon,
  },
  'products-units': {
    key: 'products-units',
    href: '/products-units',
    title: 'Products Units',
    subtitle: 'Маркетинг по SKU',
    icon: Inventory2OutlinedIcon,
  },
  'products-seo': {
    key: 'products-seo',
    href: '/products-seo',
    title: 'SEO Products',
    subtitle: 'Мета и тексты карточек',
    icon: SearchOutlinedIcon,
  },
  'products-faq': {
    key: 'products-faq',
    href: '/products-faq',
    title: 'ЧАВО товаров',
    subtitle: 'Dialog подбора · MCP',
    icon: HelpOutlineOutlinedIcon,
  },
  indexing: {
    key: 'indexing',
    href: '/indexing',
    title: 'AI Indexing',
    subtitle: 'Яндекс · индексация',
    icon: TravelExploreOutlinedIcon,
  },
};
